import React, { ReactElement, useContext } from "react";

// types
import { AnalyticsContext } from "@swiggy-private/checkout-core";

// components
import { NewTag, useEffectOnce } from "@swiggy-private/core-ui";

// hooks
import { useToingDeliveryModesAnalytics } from "@cart-client/hooks/useToingDeliveryModesAnalytics";

// styles
import { NewTagFtueWrapper } from "./DeliveryTypeTabFtueNewTag.style";

export function DeliveryTypeTabFtueNewTag(): ReactElement {
    const { impressionEvent } = useContext(AnalyticsContext);
    const { impressionFtueDeliveryModeNewTag } = useToingDeliveryModesAnalytics();

    useEffectOnce(() => impressionFtueDeliveryModeNewTag(impressionEvent));

    return (
        <NewTagFtueWrapper>
            <NewTag customBorderRadius="8px 8px 8px 0" />
        </NewTagFtueWrapper>
    );
}
